import { Component, ErrorHandler, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../shared/user.service';


@Component({
  selector: 'app-appform-payment-summary',
  templateUrl: './appform-payment-summary.component.html',
  styleUrls: ['./appform-payment-summary.component.css']
})
export class AppformPaymentSummaryComponent implements OnInit {
  data: any;
  payment: any= {};
  APP_REG_NO: any;
  private popstateHandler: () => void;
 

  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) {
  }

  ngOnInit() {
    //this.disableBrowserBack();
    
  //  this.getRegpaymentsummary(this.APP_REG_NO);
    this.route.queryParams.subscribe(params => {
    const appNo = params['appNo'];
    if (!appNo || !sessionStorage.getItem('step6Completed')) {
      this.router.navigate(['/applicant-register']);
      return;
    }
    sessionStorage.removeItem('step6Completed');  // ← consume

    if (appNo) {
      this.getappformpaymentsummary(appNo);
    }
  });
  }


  //    ngOnDestroy() {
  //   // Clean up listener when navigating away via NEXT button (not back button)
  //   window.removeEventListener('popstate', this.popstateHandler);
  // }

  // private disableBrowserBack(): void {
  //   // Step 1: Push a duplicate entry into history so back button hits THIS page
  //   // instead of the previous step (Step 6 / payment page)
  //   history.pushState(null, '', window.location.href);

  //   // Step 2: Every time popstate fires (browser back/forward pressed),
  //   // push forward again — trapping the user on this page
  //   this.popstateHandler = () => {
  //     history.pushState(null, '', window.location.href);
  //   };

  //   window.addEventListener('popstate', this.popstateHandler);
  // }




  

   getappformpaymentsummary(APP_No) {
   
  document.getElementById('loader-spinner').style.display = "block";

  this.data = this.userService.getappformpaymentsummary(APP_No);
  this.data.subscribe(
    (response: any) => {
      this.payment = response;
      if(this.payment.Payment_Method === 'Challan'){
        this.payment.Online_Payment_Date = 'NA'
      }
       if(this.payment.Payment_Method === 'Online'){
        this.payment.Challan_Payment_Date = 'NA'
      }
      // this.router.navigate(['/page1']);
      document.getElementById('loader-spinner').style.display = "none";
    },
    (error) => {
      document.getElementById('loader-spinner').style.display = "none";
      this.errorHandler.handleError(error);
    }
  );
}

printPage() {
  window.print();
}


}




// WEBPACK FOOTER //
// ./src/app/registration/appform-payment-summary/appform-payment-summary.component.ts